module.exports = __webpack_public_path__ + "static/media/patient.ac701767.png";